import { render } from "./MoveOrdersForward.vue?vue&type=template&id=1edb324e&scoped=true"
import script from "./MoveOrdersForward.vue?vue&type=script&lang=js"
export * from "./MoveOrdersForward.vue?vue&type=script&lang=js"

import "./MoveOrdersForward.vue?vue&type=style&index=0&id=1edb324e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1edb324e"]])

export default __exports__